"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_SigilOfDamnationEffectHandler = exports.Passive_SigilOfDamnationEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class Passive_SigilOfDamnationEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Passive_SigilOfDamnation;
        this.__typeName = "Passive_SigilOfDamnation";
        this.name = "Sigil of Damnation";
        this.harmful = false;
    }
}
exports.Passive_SigilOfDamnationEffectArgs = Passive_SigilOfDamnationEffectArgs;
let Passive_SigilOfDamnationEffectHandler = class Passive_SigilOfDamnationEffectHandler {
    apply(sequence, container, state) {
        state.meta.hasteEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.creatorId,
            effect: new _1.HasteEffectArgs(1),
            duration: Duration_1.Duration.Permanent,
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.hasteEffectId);
    }
};
Passive_SigilOfDamnationEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_SigilOfDamnation)
], Passive_SigilOfDamnationEffectHandler);
exports.Passive_SigilOfDamnationEffectHandler = Passive_SigilOfDamnationEffectHandler;
